import { render, staticRenderFns } from "./textContainer.vue?vue&type=template&id=63991391&scoped=true&"
import script from "./textContainer.vue?vue&type=script&lang=js&"
export * from "./textContainer.vue?vue&type=script&lang=js&"
import style0 from "./textContainer.vue?vue&type=style&index=0&id=63991391&lang=scss&scoped=true&"
import style1 from "./textContainer.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63991391",
  null
  
)

export default component.exports